import {useEffect, useMemo, useState} from "react";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import useQueryCaller from "../../../hooks/useQueryCaller";
import {getAnimalParametersFirstFetching} from "../../../selectors/animalParametersSelector";
import {makeGetTechnologyGroupSettings} from "../../../selectors/settingsSelector";
import {
    formatTechnoGroupName,
    getLastTechnologyGroups,
    getTechnologyGroupsAnimals,
} from "../../../utils/TechnologyGroupUtils";
import Select from "../../basics/select/Select";
import "./_technology-group-select.scss";

export const useLatestTechnologyGroups = (numberOfWeeksToFetch = 26) => {
    const [groups, setGroups] = useState([]);

    const queryCaller = useQueryCaller();

    const getTechnologyGroupSettings = useMemo(
        () => makeGetTechnologyGroupSettings(),
        []
    );
    const technologyGroupSettings = useSelector(getTechnologyGroupSettings);

    useEffect(() => {
        async function fetchData() {
            const lastGroups = getLastTechnologyGroups(
                technologyGroupSettings,
                Math.ceil(numberOfWeeksToFetch / technologyGroupSettings.weeks)
            );
            const tmp = lastGroups.map((item) =>
                formatTechnoGroupName(item, true)
            );
            const res = await getTechnologyGroupsAnimals(tmp, queryCaller);
            setGroups(
                tmp
                    .map((group) => ({
                        value: {AnmIDs: res[group]?.animals || [], group},
                        name: group,
                    }))
                    .reverse()
            );
        }

        fetchData();
    }, [queryCaller, numberOfWeeksToFetch, technologyGroupSettings]);

    return groups;
};

function TechnologyGroupSelectRenderer({value, onFocus, onChange}) {
    const {t} = useTranslation();

    const groups = useLatestTechnologyGroups();

    return (
        <div className="technology-group-select">
            <Select
                value={value}
                onFocus={onFocus}
                options={groups}
                onChange={onChange}
                placeholder={t("technologyGroup")}
                callOnChangeOnSingleOption={false}
            />
        </div>
    );
}

export default function TechnologyGroupSelect({value, onFocus, onChange}) {
    const firstFetchingParams = useSelector(getAnimalParametersFirstFetching);

    if (firstFetchingParams) {
        return (
            <div className="position-relative w-100 h-100">
                <div className="technology-group-select-loading">
                    <i className="fas fa-circle-notch fa-spin" />
                </div>
            </div>
        );
    }
    return (
        <TechnologyGroupSelectRenderer
            value={value}
            onFocus={onFocus}
            onChange={onChange}
        />
    );
}
